module.exports = __webpack_public_path__ + "static/media/anpost.055e15f9.png";